export const googleAuthMigrations = [
  {
    id: '045_google_authentication',
    sql: `
      CREATE TABLE google_auth_identities (
        provider_subject TEXT PRIMARY KEY,
        user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        email_at_link TEXT NOT NULL,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        last_login_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        UNIQUE (user_id)
      );

      CREATE TABLE google_auth_attempts (
        state_hash TEXT PRIMARY KEY,
        code_verifier TEXT NOT NULL,
        return_url TEXT NOT NULL,
        expires_at TIMESTAMPTZ NOT NULL,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW()
      );
      CREATE INDEX google_auth_attempts_expiry_idx ON google_auth_attempts (expires_at);

      CREATE TABLE google_auth_tickets (
        ticket_hash TEXT PRIMARY KEY,
        user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        expires_at TIMESTAMPTZ NOT NULL,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW()
      );
      CREATE INDEX google_auth_tickets_expiry_idx ON google_auth_tickets (expires_at);
    `,
  },
] as const;
